import { SourcingLoadingIndicator } from 'common/animations/SourcingLoadingIndicator';

export const SourcingExternalGeneratingSearchStep = () => (
  <SourcingLoadingIndicator title="Building a search from your job description." />
);
